import _ from 'lodash'
import moment from 'moment'
import ajax from '../../api/ajax'
import { RegionGroup } from '../../constant/common'


const state = {
	selectOriginAreaCode: '',     	   			// 选择的原寄地code值
	selectOriginCityCode: '',     	   			// 选择的原寄地城市代码
	selectOriginProvinceCode: '', 	   			// 选择的原寄地省代码(大陆)
	selectOriginAreaName: '请选择原寄地',     	// 选择的原寄地地址名
	selectOriginCurrentTabId: 'chinaArea',    	// 原寄地当前tabId默认中国大陆
	selectDestAreaCode: '',     				// 选择的目的地code值
	selectDestCityCode: '',     				// 选择的目的城市代码
	selectDestProvinceCode: '', 				// 选择的目的省代码(大陆)
	selectDestAreaName: '请选择目的地', // 选择的目的地地址名
	selectDestCurrentTabId: 'chinaArea',    			// 目的地当前tabId默认中国大陆
	weight: 1,									// 重量
	lengthInput: 0,								// 长
	widthInput: 0,								// 宽
	heightInput: 0,								// 高
	sendTime: '现在',							// 寄件时间
	rateInfoArr: [],							// 后台返回的时效产品数据
	showResult: false,            				// 是否展示查询结果
	errorMsg: '',                 				// 错误信息
	showDefaultProduct: false            		// 是否显示默认时效产品
}

const getters = {
	// 查询按钮是否可点击
	disabledBtn (state) {
		return !state.selectOriginAreaCode || !state.selectDestAreaCode
	},
	//体积
	volume (state) {
		return state.lengthInput * state.widthInput * state.heightInput
	}
}

const mutations = {
	// 是否显示结果栏
	showResult (state, isShow) {
		state.showResult = isShow
	},

	// 省市区数据
	selectRegion (state, item) {
		if (item.isOrigin) { // 原寄地
			state.selectOriginAreaCode = item.selectCode
			state.selectOriginCityCode = item.selectCityCode
			state.selectOriginProvinceCode = item.selectProvinceCode
			state.selectOriginAreaName = item.selectName
			state.selectOriginCurrentTabId = item.currentTabId
		} else { // 目的地
			state.selectDestAreaCode = item.selectCode
			state.selectDestCityCode = item.selectCityCode
			state.selectDestProvinceCode = item.selectProvinceCode
			state.selectDestAreaName = item.selectName
			state.selectDestCurrentTabId = item.currentTabId
		}
		state.showResult = false
	},

	/**
	 * 更新weight
	 * @param state
	 * @param weight
	 */
	updateWeight (state, weight) {
		state.weight = weight
	},

	/**
	 * 更新lengthInput
	 * @param state
	 * @param lengthInput
	 */
	updateLengthInput (state, lengthInput) {
		state.lengthInput = lengthInput
	},

	/**
	 * 更新lengthInput
	 * @param state
	 * @param widthInput
	 */
	updateWidthInput (state, widthInput) {
		state.widthInput = widthInput
	},

	/**
	 * 更新heightInput
	 * @param state
	 * @param heightInput
	 */
	updateHeightInput (state, heightInput) {
		state.heightInput = heightInput
	},

	//处理请求成功的情况
	handleSuccess (state, data) {
		let result = data
		//根据cargoTypeCode，limitTypeCode和distanceTypeCode去重
		// result = _.uniqBy(data, ['cargoTypeCode', 'limitTypeCode', 'distanceTypeCode'])
		// result = _.uniqBy(data, function (rateObj) {
		// 	return rateObj.cargoTypeCode && rateObj.limitTypeCode && rateObj.distanceTypeCode
		// })
		//如果存在郊区件，则只显示郊区件的价格
		const outskirtsData = _.filter(result, function (obj) {
			return obj.distanceTypeCode === 'R10202'
		})
		if (outskirtsData && outskirtsData.length > 0) {
			result = outskirtsData
		}
		state.rateInfoArr = result
		state.showDefaultProduct = false
		state.showResult = true
	},

	//处理请求失败的情况
	handleError (state, res) {
		state.showDefaultProduct = true
	}
}

const actions = {
	/**
	 * 查询运费时效数据
	 * @param commit
	 * @param state
	 * @param getters
	 */
	getPayFee ({commit, state, getters}) {
		let deliverTime;
		if (state.sendTime === '现在' || state.sendTime === 'Now') {
			const newTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
			const newDate = newTime.substr(0, 10);
			const newHour = newTime.substr(11, 8);
			deliverTime = newDate + 'T' + newHour + '+08:00';
		} else {
			deliverTime = state.sendTime.substr(0, 10) + 'T' + state.sendTime.substr(11, 5) + ':00+08:00';
		}
		ajax.getPayFee({
			params: {
				origin: RegionGroup.HMTArray.indexOf(state.selectOriginProvinceCode) === -1
					? state.selectOriginAreaCode : state.selectOriginCityCode,
				dest: RegionGroup.HMTArray.indexOf(state.selectDestProvinceCode) === -1
					? state.selectDestAreaCode : state.selectDestCityCode,
				weight: state.weight,
				time: deliverTime,
				volume: getters.volume
			}
		}).then(response => commit('handleSuccess', response.data))
			.catch(response => commit('handleError', response))
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/payFee.js